// extracted by mini-css-extract-plugin
module.exports = {"page":"_13928","bd":"_12790","qrcode":"_15341","message":"_7425"};